import type { PartnerConfig } from "@/content/partners/types"

export const VIENA_PARTNER_SLUG = "viena"

export const VIENA_LOGO_PATH = "/partners/viena/logo.svg"

export const vienaBrand = {
  accent: "#ed1c24",
  accentDark: "#b9151c",
  accentLight: "#fca5a5",
  navy: "#304269",
  ringFrom: "#ed1c24",
  ringTo: "#304269",
  benefit: "#4ade80",
  benefitForeground: "#002a50",
} as const

export const vienaPartnerConfig: PartnerConfig = {
  slug: VIENA_PARTNER_SLUG,
  name: "Viena",
  fullName: "Grupo Viena",
  logoPath: VIENA_LOGO_PATH,
  benefitMode: "next_band",
  isActive: true,
  metadata: {
    website: "https://vienairon.com.br/",
    industry: "siderurgia",
  },
}

export const vienaPartnerContent = {
  ...vienaPartnerConfig,
  tagline: "Siderurgia, construção, agronegócio e energia solar",
  websiteUrl: "https://vienairon.com.br/",
  benefitHeadline: "Benefício para colaboradores",
  heroHeadline: "Colaboradores do Grupo Viena têm desconto extra na energia",
  heroSubtitle: "Energia solar por assinatura, sem obra e sem investimento inicial.",
  partnershipIntro:
    "Colaboradores de todas as empresas do grupo têm desconto extra na energia por assinatura — cadastro simples, benefício automático.",
  partnershipEnergyTitle: "Energia de ponta a ponta",
  partnershipEnergySubtitle: "Da usina à sua conta",
  partnershipEnergyHighlight:
    "As usinas fotovoltaicas do grupo são fornecedoras da energia solar que a Astra entrega aos clientes — quem faz parte do Grupo Viena economiza na própria conta com a mesma fonte limpa que ajuda a produzir.",
  partnershipEnergyFlow: [
    {
      title: "UFVs do grupo",
      description: "Geração solar nas usinas do Grupo Viena",
    },
    {
      title: "Astra Energia",
      description: "Energia limpa entregue aos assinantes",
    },
    {
      title: "Sua conta",
      description: "Economia direto na fatura Cemig",
    },
  ],
  partnershipTitle: "Grupo Viena e energia limpa, juntos",
} as const
